<template>
	<div class="responsible-form">
		<el-form :model="pickUpResponsible" class="d-flex justify-center wrap">
			<el-form-item
				class="flex-40 input-responsible"
				prop="name"
				label="Persona que recogerá el pedido"
			>
				<el-input
					v-model="pickUpResponsible.name"
					@input="gettingData"
					placeholder="Persona que recogerá el pedido"
				></el-input>
			</el-form-item>
			<el-form-item
				class="flex-40 input-responsible"
				prop="dni"
				label="Número de documento"
			>
				<el-input
					v-model="pickUpResponsible.dni"
					@input="gettingData"
					placeholder="Número de documento"
				></el-input>
			</el-form-item>
			<el-form-item
				class="flex-40 input-responsible"
				prop="phone"
				label="Teléfono"
			>
				<el-input
					type="tel"
					v-model="pickUpResponsible.phone"
					@input="gettingData"
					placeholder="Teléfono"
				></el-input>
			</el-form-item>
			<el-form-item
				class="flex-40 input-responsible"
				prop="email"
				label="Correo electrónico"
			>
				<el-input
					type="email"
					v-model="pickUpResponsible.email"
					@input="gettingData"
					placeholder="Correo electrónico"
				></el-input>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>

function gettingData() {
	this.$emit('responsible', this.pickUpResponsible);
}

function data() {
	return {
		pickUpResponsible: {
			name: '',
			dni: '',
			phone: '',
			email: '',
		},
	};
}

export default {
	name: 'pick-up',
	data,
	methods: {
		gettingData,
	},
};
</script>
<style lang="scss" scoped>

	.responsible-form {
		margin: 2.2rem auto 0;
	}

	.input-responsible {
		margin: 0 1rem 2rem;
		min-width: 28rem;
	}
</style>



// WEBPACK FOOTER //
// pickUp.vue?fc8af1da